import { render, staticRenderFns } from "./WhitelistFormModal.vue?vue&type=template&id=1dd68b2f&scoped=true&"
import script from "./WhitelistFormModal.vue?vue&type=script&lang=js&"
export * from "./WhitelistFormModal.vue?vue&type=script&lang=js&"
import style0 from "./WhitelistFormModal.vue?vue&type=style&index=0&id=1dd68b2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd68b2f",
  null
  
)

export default component.exports